<script>
// @ts-check

export default {
  data: function() {
    return {}
  },
}
</script>

<template>
  <v-card style="min-width:320px">
    <v-card-text>
      <b>STAAR Outcomes</b> - Percentage of students who Approach Grade Level Standard or Above (All Grades); meet Grade Level Standard; or Master Grade Level Standard.
    </v-card-text>
  </v-card>
</template>
